import { render, staticRenderFns } from "./EditLiveEditCategoryTab.vue?vue&type=template&id=0ab65099"
import script from "./EditLiveEditCategoryTab.vue?vue&type=script&lang=js"
export * from "./EditLiveEditCategoryTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports